module.exports = __webpack_public_path__ + "assets/Angle75Detailed.bb76eb7286850769cc5d2fa3f4088f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Angle75Detailed.png
// module id = 465
// module chunks = 0